import AxiosInterceptor from "../../AxiosInterceptorAlcohol";

// push 캠페인 등록
export function postPushMessageToAlcohol(request) {
    return AxiosInterceptor({
        url: '/push/camp',
        method: 'post',
        data: request
    })
}

// push 캠페인 조회
export function getPushMessageFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/push/camp',
        method: 'get',
        params: request
    })
}


// 환자에게 발송된 메시지 조회
// request data
//  - pid
//  - start : 시작 날짜
//  - end : 끝 날짜
//  - text : 내용
export function getMessageToPatientFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/messages',
        method: 'get',
        params: request
    })
}


// 환자에게 메시지 전송
// request data
//  - pid
//  - name : 보내는 사람 이름
//  - message : 메시지 내용
export function postMessageFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/messages',
        method: 'post',
        data: request
    })
}
